import moment from 'moment';

//import 'moment/min/locales.min';
//moment.locale(navigator.language || navigator.userLanguage);

moment.updateLocale('en', {
    week : {
        dow : 1, // Monday is the first day of the week.
    }
});


// WEBPACK FOOTER //
// ./components/config.js